// Do NOT change these constants

export const OPTIONS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

export const POSSIBLEROLESARRAY: Array<string> = ["admin", "tester", "viewer", "customer_viewer"]